module.exports = __webpack_public_path__ + "img/medium.bc6ede5a.svg";